<template>
	<div class="tusd-wrap wrap-bg alipay">
		<div class="page-title">
			<i class="back-btn" @click="goBack"></i>
			修改固定收款方式
		</div>
		<div class="separator"></div>
		<div class="account-wrap">

			<div class="wrap-item">
				<span class="item-label">
					支付宝账号：
				</span>
				<input type="text" v-model="account.BankAccount" placeholder="请输入支付宝账号"
					:disabled="(this.account.amountType == 2 ? 'disabled' : '')" />
			</div>
			<div class="wrap-item">
				<span class="item-label">
					收款方全称：
				</span>
				<input type="text" v-model="account.BankUser" placeholder="请输入收款方全称" />
			</div>
			<div class="wrap-item">
				<span class="item-label">分组管理：</span>
				<cube-select v-model="account.groupId" :options="bankGroupOptions"
					@change="selectBankGroup"></cube-select>
			</div>
			<div class="wrap-item">
				<span class="item-label">收款人编号：</span>
				<input type="text" v-model="account.BankRemark" placeholder="请输入收款方编号" />
			</div>
			<div class="wrap-item">
				<span class="item-label">固定金额：</span>
				<span class="unit">元</span>
				<input type="number" v-model="account.amountFixed" placeholder="金额类型=固定，必须输入"
					:disabled="(this.account.amountType == 2 ? 'disabled' : '')" />
			</div>
			<div class="wrap-item">
				<span class="item-label">是否启用：</span>
				<div class="radio-wrap">
					<cube-radio-group @input="changeStatus" v-model="optionCheckedValue.status" :options="statusOptions"
						:horizontal="true" />
				</div>
			</div>
			 <div class="wrap-item">
				<span class="item-label">订单客户：</span>
				<div class="radio-wrap">
					<cube-radio-group
					@input="changePaymentCustomerLimit"
					v-model="optionCheckedValue.paymentCustomerLimitValue"
					:options="paymentCustomerLimitOptions"
					:horizontal="true"
					/>
			    </div>
			</div>
			<div class="wrap-item">
				<span class="item-label">可用收款码：</span>
				<span class="unit">个</span>
				<input type="text" v-model="validQrCodeCount" />
			</div>
			<div class="wrap-item item_top2">
				<span class="item-label">固定金额码：</span>
				<cube-upload class="header-wrap" ref="uploadFile" :max="10" :auto="false" :simultaneous-uploads="50"
					@files-added="filesAdded">
					<cube-upload-btn :multiple="true">
						<div class="upload-btn2">
							<i></i>
						</div>
					</cube-upload-btn>
				</cube-upload>
				<div class="img-name">
					<p v-for="image in account.QRCodeUrls" :key="image.fileName">{{ image.originName }}</p>
				</div>
			</div>
			<div class="tusd-btn first-btn" @click="addAccount">确认修改</div>
			<div class="tusd-btn tusd-btn-danger first-btn" @click="deleteBank">删除</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'editFixedLimitQrcode',
	data() {
		return {
			account: {
				id: 0,
				BankUser: "",
				BankAccount: "",
				IsUse: 1,
				groupId: "",
				bankRemark: "",
				QRCodeUrls: [],
				PaymentCustomerLimit:0

			},
			validQrCodeCount: 0,
			bankGroupOptions: [],
			params: {},
			fixedLimitOptions: [],
			statusOptions: ["是", "否"],
			optionCheckedValue: {
				status: "否",
				paymentCustomerLimitValue:"全部",
			},
			status: [
				{
					label: "是",
					value: 1
				},
				{
					label: "否",
					value: 0
				}
			],
			paymentCustomerLimitOptions: ["全部","正常","新疆"],
			paymentCustomerLimitProp: [
				{
				label: "全部",
				value: 0
				},
				{
				label: "正常",
				value: 1
				}
				,
				{
				label: "新疆",
				value: 2
				}
			],
		};
	},
	methods: {
		getUserByBankId(bankId) {
			this.$api.getUserByBankId(bankId).then(res => {
				let data = res.data;
				this.common.copyObj(this.account, data);
				this.account.BankAccount = data.BankAccount;
				this.account.BankUser = data.BankUser;
				this.account.BankRemark = data.BankRemark;
				this.account.id = this.params.bankId
				this.account.groupId = data.GroupId;
				this.account.amountType = data.AmountType;
				this.account.amountFixed = data.AmountFixed;
				this.account.amountType = data.AmountType;
				this.optionCheckedValue.status = this.getProp(data.IsUse, this.status, true);
				this.optionCheckedValue.paymentCustomerLimitValue = this.getProp(data.PaymentCustomerLimit, this.paymentCustomerLimitProp, true);
			});
		},
		selectBankGroup(value, index, text) {
			this.account.groupId = value;
		},
		getUserBankGroupList() {
			let that = this;
			this.$api.getUserBankGroups().then((res) => {
				res.data.filter((item) => item.PayType == 2).map(v => {
					let temp = { text: v.Title, value: v.Id };
					that.bankGroupOptions.push(temp)
				})
			});
		},
		goBack() {
			this.$router.push({ name: this.params.back });
		},

		getProp(v, o, r) {
			let prop = '';
			o.map(i => {
				if (r) {
					if (i.value == v) {
						prop = i.label;
					}
				} else {
					if (i.label == v) {
						prop = i.value;
					}
				}
			});
			return prop;
		},
		changeStatus(v) {
			this.account.IsUse = this.getProp(v, this.status);
		},
		changePaymentCustomerLimit(v) {
		  this.account.PaymentCustomerLimit = this.getProp(v, this.paymentCustomerLimitProp);
		},
		addAccount() {
			let that = this;
			if (!that.account.QRCodeUrls) {
				that.$message.popup("请至少上传一个收款码", 1000);
				return false
			}
			that.$api.editFixedAlipay(that.account).then((res) => {
				that.$message.popup(res.msg, 1000);
				that.goBack();
			})
		},
		filesAdded(files) {
			if (!this.account.BankAccount) {
				this.$message.popup("请填写您的支付宝账号！", 1000);
				return;
			}
			let hasIgnore = false;
			const limitSize = 2 * 1024 * 1024;
			// 最大5M
			const maxSize = 5 * 1024 * 1024;
			for (let i = 0; i < files.length; i++) {
				const file = files[i];
				// 如果选择的图片大小最大限制（这里为5M）则弹出提示
				if (file.size > maxSize) {
					file.ignore = true;
					hasIgnore = true;
					break;
				}
				// 如果选择的图片大小大于1M则进行图片压缩处理（Base64）
				let imageData;
				if (file.size > limitSize) {
					this.compressPic(file);
				} else {
					let reads = new FileReader();
					reads.readAsDataURL(file);
					let that = this;

					reads.onload = function (e) {
						var bdata = this.result;
						file.base64 = bdata;
						that.hasChange = true;
						//that.creditQrImgArray.push(bdata);
						imageData = bdata;

						that.filesSubmit(bdata, file.name);
					};
				}
			}
			hasIgnore && this.$message.popup("图片最大支持5M", 1000);
		},
		filesSubmit(imgData, fileName) {
			let that = this;
			if (!this.account.BankAccount) {
				this.$message.popup("请填写您的支付宝账号！", 1000);
				return;
			}
			var data = {
				file: imgData,
				path: '/files/alipay/fixedamount/' + this.account.BankAccount + '/',
				fileName: fileName
			}
			this.$api.alipayImgListUpload(data).then((res) => {
				if (!that.account.QRCodeUrls) {
					that.account.QRCodeUrls = [];
				}
				that.account.QRCodeUrls.push(res.data);
			})
		},
		deleteBank() {
			let that = this;
			that.$message.confirm("提示", "您确定要删除吗？", () => {
				that.$api.deleteBank(this.params.bankId).then(res => {
					that.$message.popup("删除支付宝账户成功", 1000);
					that.goBack();
				});
			});
		},
		validFixedQrCodeCount(userId, bankId) {
			let that = this;
			this.$api.validFixedQrCodeCount(userId, bankId).then((res) => {
				that.validQrCodeCount = res.data;
			});
		}
	},
	created() {
		var userInfo = this.$store.state.userInfo;
		this.params = this.$store.state.routerStore.editFixedLimitQrcode;
		if (!this.params.back) {
			this.params.back = 'accounts';
		}
		this.getUserByBankId(this.params.bankId);
		this.validFixedQrCodeCount(userInfo.UserID, this.params.bankId);
		this.getUserBankGroupList();
	}
};
</script>
<style lang="less" scoped>
.img-name {
	color: #8092c6;
}

.header-wrap {
	display: inline-block;
	width: 80px;
	height: 80px;
	margin: 15px 0;

	.upload-btn {
		width: 100%;
		height: 100%;
		background: url(../assets/images/header.png) center center no-repeat;
		background-size: contain;
		border: 2px solid #cdcdcd;

		i {
			display: inline-block;
			vertical-align: middle;
			width: 75px;
			height: 80px;
			margin-right: 8px;
			background: url(../assets/images/upload.svg) center center no-repeat;
		}

	}

	.upload-btn2 {
		width: 100%;
		height: 100%;
		background-size: contain;
		border: 2px solid #cdcdcd;

		i {
			display: inline-block;
			vertical-align: middle;
			width: 75px;
			height: 80px;
			margin-right: 8px;
			background: url(../assets/images/upload.svg) center center no-repeat;
		}

	}

	.cube-upload-btn {
		height: 100%;
	}

}

.item_top {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
}

.item_top2 {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	flex-wrap: wrap;
}
</style>